<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-select ttLabel="resource_name" [(ttModel)]="page.resource_id" [ttData]="resources" ttDataId="resource_id" ttDataName="resource_name" ttRequired></tt-select>
        <tt-datetime ttLabel="first_alert" [(ttModel)]="page.first_alert" ttMinutePrecision="1" ttRequired></tt-datetime>
        <tt-select ttLabel="special_event" [ttModel]="page.special_event_id" (ttModelChange)="onEventChanged($event)" [ttData]="events" ttDataId="event_id" ttDataName="event_name" ttRequired></tt-select>
        <tt-input ttLabel="special_where" [(ttModel)]="page.special_where" ttShowClearButton ttRequired></tt-input>
        <tt-input ttLabel="special_object" [(ttModel)]="page.special_object" ttShowClearButton ttRequired></tt-input>
        <hr>
        <tt-button-save ttText="srnotcompletednew_save" [ttLoading]="saving" (ttClick)="save()"></tt-button-save>
    </tt-card>
</tt-page>
